<template>
    <div id="service">
        <div class="mx-3 2xl:px-40 lg:pb-20">
            <div class="mb-10 text-center pt-20">
                <h1 class="mb-0 text-lg text-center font-bold">Keunggulan Kami</h1>
            </div>
            <div class="text-center grid justify-items-center grid-cols-2 gap-4 lg:grid-cols-4 pb-4">
                <div
                    class="border-solid border-4 border-primary transition duration-300 ease-in-out hover:bg-oren block max-w-[400px] rounded-[20px] shadow-lg bg-bodas bg-opacity-50 mb-10 lg:mb-10 lg:w-[300px]">
                    <div class="p-4">
                        <img src="@/assets/proO.png" alt="catra" class="inline h-[80px] mb-3" />
                        <h1 class="text-center mb-5 text-base font-normal leading-tight text-hideung">PRODUK ORIGINAL</h1>
                    </div>
                </div>
                <div
                    class="border-solid border-4 border-primary transition duration-300 ease-in-out hover:bg-oren block max-w-[400px] rounded-[20px] shadow-lg bg-bodas bg-opacity-50 mb-10 lg:mb-10 lg:w-[300px]">
                    <div class="p-4">
                        <img src="@/assets/garansi.png" alt="catra" class="inline h-[80px] mb-3" />
                        <h1 class="text-center mb-5 text-base font-normal leading-tight text-hideung">GARANSI RESMI MERK
                        </h1>
                    </div>
                </div>
                <div
                    class="border-solid border-4 border-primary transition duration-300 ease-in-out hover:bg-oren block max-w-[400px] rounded-[20px] shadow-lg bg-bodas bg-opacity-50 mb-10 lg:mb-10 lg:w-[300px]">
                    <div class="p-4">
                        <img src="@/assets/teknisi.png" alt="catra" class="inline h-[80px] mb-3" />
                        <h1 class="text-center mb-5 text-base font-normal leading-tight text-hideung">GARANSI JASA TEKNISI</h1>
                    </div>
                </div>
                <div
                    class="border-solid border-4 border-primary transition duration-300 ease-in-out hover:bg-oren block max-w-[400px] rounded-[20px] shadow-lg bg-bodas bg-opacity-50 mb-10 lg:mb-10 lg:w-[300px]">
                    <div class="p-4">
                        <img src="@/assets/harga.png" alt="catra" class="inline h-[80px] mb-3" />
                        <h1 class="text-center mb-5 text-base font-normal leading-tight text-hideung">HARGA TERJANGKAU DI BANDING YANG LAIN DENGAN PRODUK YANG SAMA</h1>
                    </div>
                </div>
            </div>
            <div class="text-center grid justify-items-center grid-cols-2 gap-4 lg:grid-cols-4 pb-5">
                <div
                    class="border-solid border-4 border-primary transition duration-300 ease-in-out hover:bg-oren block max-w-[400px] rounded-[20px] shadow-lg bg-bodas bg-opacity-50 mb-10 lg:mb-10 lg:w-[300px]">
                    <div class="p-4">
                        <img src="@/assets/prof.png" alt="catra" class="inline h-[80px] mb-3" />
                        <h1 class="text-center mb-5 text-base font-normal leading-tight text-hideung">TEKNISI PROFESIONAL, HASIL PEMASANGAN RAPI DAN AMAN</h1>
                    </div>
                </div>
                <div
                    class="border-solid border-4 border-primary transition duration-300 ease-in-out hover:bg-oren block max-w-[400px] rounded-[20px] shadow-lg bg-bodas bg-opacity-50 mb-10 lg:mb-10 lg:w-[300px]">
                    <div class="p-4">
                        <img src="@/assets/survei.png" alt="catra" class="inline h-[80px] mb-3" />
                        <h1 class="text-center mb-5 text-base font-normal leading-tight text-hideung">SURVEI LOKASI DAN KONSULTASI GRATIS
                        </h1>
                    </div>
                </div>
                <div
                    class="border-solid border-4 border-primary transition duration-300 ease-in-out hover:bg-oren block max-w-[400px] rounded-[20px] shadow-lg bg-bodas bg-opacity-50 mb-10 lg:mb-10 lg:w-[300px]">
                    <div class="p-4">
                        <img src="@/assets/legal.png" alt="catra" class="inline h-[80px] mb-3" />
                        <h1 class="text-center mb-5 text-base font-normal leading-tight text-hideung">KAMI SUDAH MEMILIKI IZIN USAHA RESMI</h1>
                    </div>
                </div>
                <div
                    class="border-solid border-4 border-primary transition duration-300 ease-in-out hover:bg-oren block max-w-[400px] rounded-[20px] shadow-lg bg-bodas bg-opacity-50 mb-10 lg:mb-10 lg:w-[300px]">
                    <div class="p-4">
                        <img src="@/assets/promo.png" alt="catra" class="inline h-[80px] mb-3" />
                        <h1 class="text-center mb-5 text-base font-normal leading-tight text-hideung">BANYAK PROMO DAN BONUS PERLENGKAPAN CCTV</h1>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import "@/assets/tailwind.css";

export default {};
</script>

<style></style>